import { render } from "./plan-credits.vue?vue&type=template&id=4615bfee"
import script from "./plan-credits.vue?vue&type=script&lang=js"
export * from "./plan-credits.vue?vue&type=script&lang=js"

import "./plan-credits.vue?vue&type=style&index=0&id=4615bfee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__